'use strict';

var _defineProperty = require('@babel/runtime/helpers/defineProperty');

var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');

var React = require('react');

var ReactDOM = require('react-dom');

var reactPopper = require('react-popper');

var injectSheet = require('react-jss');

var THEME = require('pobble-components/dist/theme');

var classNames = require('classnames');

var PropTypes = require('prop-types');

var DownArrowIcon = require('react-icons/lib/fa/caret-down');

var UpArrowIcon = require('react-icons/lib/fa/caret-up');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _defineProperty__default =
/*#__PURE__*/
_interopDefaultLegacy(_defineProperty);

var _slicedToArray__default =
/*#__PURE__*/
_interopDefaultLegacy(_slicedToArray);

var React__default =
/*#__PURE__*/
_interopDefaultLegacy(React);

var ReactDOM__default =
/*#__PURE__*/
_interopDefaultLegacy(ReactDOM);

var injectSheet__default =
/*#__PURE__*/
_interopDefaultLegacy(injectSheet);

var THEME__default =
/*#__PURE__*/
_interopDefaultLegacy(THEME);

var classNames__default =
/*#__PURE__*/
_interopDefaultLegacy(classNames);

var PropTypes__default =
/*#__PURE__*/
_interopDefaultLegacy(PropTypes);

var DownArrowIcon__default =
/*#__PURE__*/
_interopDefaultLegacy(DownArrowIcon);

var UpArrowIcon__default =
/*#__PURE__*/
_interopDefaultLegacy(UpArrowIcon);

var COLORS = THEME__default["default"].COLORS;
var styles = {
  button: {
    display: 'inline-block'
  },
  tooltip: {
    display: 'inline-block',
    borderRadius: '8px',
    margin: '10px 0',
    maxWidth: '240px',
    zIndex: '11000',
    pointerEvents: 'none'
  },
  body: {
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
    display: 'inline-block',
    backgroundColor: '#313131',
    color: '#fff',
    fontSize: '14px',
    lineHeight: '16px',
    padding: '8px 12px',
    animation: 'open .2s cubic-bezier(0,0,0,1)'
  },
  closing: {
    '& $body': {
      animation: 'close .2s cubic-bezier(0,0,0,1)'
    }
  },
  danger: {
    backgroundColor: COLORS.RED.NORMAL,
    '& $arrow': {
      color: COLORS.RED.NORMAL
    }
  },
  arrow: {
    position: 'absolute',
    width: '20px',
    height: '20px',
    bottom: '-12px',
    color: '#313131',
    '& svg': {
      width: '100%',
      height: '100%'
    }
  },
  arrowBottom: {
    bottom: 'auto',
    top: '-12px'
  },
  '@keyframes open': {
    from: {
      opacity: '0',
      transform: 'translateY(-5px)'
    },
    to: {
      opacity: '1',
      transform: 'translateY(0)'
    }
  },
  '@keyframes close': {
    from: {
      opacity: '1',
      transform: 'translateY(0)'
    },
    to: {
      opacity: '0',
      transform: 'translateY(-5px)'
    }
  }
};

var Tooltip = function Tooltip(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      content = _ref.content,
      className = _ref.className,
      tooltipClassName = _ref.tooltipClassName,
      danger = _ref.danger,
      style = _ref.style,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      opened = _useState2[0],
      setOpened = _useState2[1];

  var _useState3 = React.useState('closed'),
      _useState4 = _slicedToArray__default["default"](_useState3, 2),
      transition = _useState4[0],
      setTransition = _useState4[1];

  var transitionTimeout = React.useRef(null);
  React.useEffect(function () {
    if (opened) {
      setTransition('opened');
    } else if (transition !== 'closed') {
      setTransition('closing');
      transitionTimeout.current = setTimeout(function () {
        return setTransition('closed');
      }, 200);
    }

    return function () {
      clearTimeout(transitionTimeout.current);
    };
  }, [opened]);
  var Wrapper = as;
  return (
    /*#__PURE__*/
    React__default["default"].createElement(reactPopper.Manager, null,
    /*#__PURE__*/
    React__default["default"].createElement(reactPopper.Reference, null, function (_ref2) {
      var ref = _ref2.ref;
      return (
        /*#__PURE__*/
        React__default["default"].createElement(Wrapper, {
          style: style,
          onMouseEnter: function onMouseEnter() {
            return setOpened(true);
          },
          onMouseLeave: function onMouseLeave() {
            return setOpened(false);
          },
          className: classNames__default["default"](classes.button, className),
          ref: ref
        }, children)
      );
    }), !!content && transition !== 'closed' &&
    /*#__PURE__*/
    ReactDOM__default["default"].createPortal(
    /*#__PURE__*/
    React__default["default"].createElement(reactPopper.Popper, {
      placement: "top"
    }, function (_ref3) {
      var _classNames, _classNames2;

      var ref = _ref3.ref,
          style = _ref3.style,
          placement = _ref3.placement,
          arrowProps = _ref3.arrowProps;
      return (
        /*#__PURE__*/
        React__default["default"].createElement("div", {
          ref: ref,
          style: style,
          className: classNames__default["default"](classes.tooltip, tooltipClassName, (_classNames = {}, _defineProperty__default["default"](_classNames, classes.opened, transition === 'opened'), _defineProperty__default["default"](_classNames, classes.closing, transition === 'closing'), _defineProperty__default["default"](_classNames, classes.danger, danger), _classNames)),
          "data-placement": placement
        },
        /*#__PURE__*/
        React__default["default"].createElement("div", {
          className: classes.body
        }, content,
        /*#__PURE__*/
        React__default["default"].createElement("span", {
          className: classNames__default["default"](classes.arrow, (_classNames2 = {}, _defineProperty__default["default"](_classNames2, classes.arrowTop, placement === 'top'), _defineProperty__default["default"](_classNames2, classes.arrowBottom, placement === 'bottom'), _classNames2)),
          ref: arrowProps.ref,
          style: arrowProps.style
        }, placement === 'top' &&
        /*#__PURE__*/
        React__default["default"].createElement(DownArrowIcon__default["default"], null), placement === 'bottom' &&
        /*#__PURE__*/
        React__default["default"].createElement(UpArrowIcon__default["default"], null))))
      );
    }), document.body))
  );
};

Tooltip.propTypes = {
  /** Wrapped components will be shown as is */
  children: PropTypes__default["default"].oneOfType([PropTypes__default["default"].arrayOf(PropTypes__default["default"].node), PropTypes__default["default"].node]),

  /** Content to be shown in tooltip. If null no tooltip will be shown */
  content: PropTypes__default["default"].oneOfType([PropTypes__default["default"].string, PropTypes__default["default"].node]),

  /** Additional className for children wrapper to restyle */
  className: PropTypes__default["default"].string,

  /** Show red tooltip */
  danger: PropTypes__default["default"].bool
};
var index = injectSheet__default["default"](styles)(Tooltip);
module.exports = index;